import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDialog } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { IActivity } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { AddMultipleChoiceQuestionAnswerComponent } from '../add-multiple-choice-question-answer/add-multiple-choice-question-answer.component';

@Component({
  selector: 'app-add-multiple-choice',
  templateUrl: './add-multiple-choice.component.html',
  styleUrls: ['./add-multiple-choice.component.scss']
})
export class AddMultipleChoiceComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  form: FormGroup;
  answer: AbstractControl;
  question: AbstractControl;
  answerTip: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new question';
  constructor(
    public dialogRef: MatDialogRef<AddMultipleChoiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: ActivityStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private route: Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    const { QUESTION } = this.data;
    this.store.options = [];

    this.form = this.fb.group({
      question: [QUESTION ? QUESTION.question : null, Validators.required],
    })
    if (QUESTION) {
      this.TITLE = "Edit question";
      this.store.options = QUESTION.answers
    }
  }

  delete(item: any) {
    this.store.options = this.store.options.filter(m => m.key !== item.key) || [];
  }

  addNewLine(item: any) {
    let dialogRef = this.dialog.open(AddMultipleChoiceQuestionAnswerComponent, {
      data: {
        QUESTION: this.data.QUESTION || {},
        ANSWER: item || null,
      },
      panelClass: 'item-list-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { question } = f;
      const { FORM, ITEM, SKILL, ACTIVITY_TYPE, MODULE_KEY, QUESTION, ACTIVITY_TYPE_OBJECT, SKILL_NAME } = this.data;
      const { name, instruction, defaultInstruction, grammar } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const { options } = this.store;
      const questions = ITEM ? ITEM.questions : []
      const row = {
        key: QUESTION ? QUESTION.key : this.ds.createId(),
        question,
        answers: options,
      };
      const ANSWER_DATA = pushObjArray(questions, row)
      const registerStatus = STATUS_OBJECT.submitted;

      const activity: IActivity = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        hasSubActivity: true,
        //fields
        name: name || null,
        grammar: grammar || null,
        instruction: instruction || null,
        defaultInstruction: defaultInstruction || false,
        questions: ANSWER_DATA,
        soundDownloadURL: ITEM ? ITEM.soundDownloadURL || null : null,
        //modules
        skillKey: SKILL,
        skillRef: this.ds.skillRef().doc(SKILL).ref,
        skillName: SKILL_NAME,
        activityTypeKey: ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE).ref,
        activityTypeName: ACTIVITY_TYPE_OBJECT.name,
        moduleKey: MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(MODULE_KEY).ref,
      }
      this.store.addItem(activity, this.data.MODULE, ITEM ? true : false, (success, res) => {
        this.data.ITEM = activity;
        this.store.options = [];
        this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
        if (QUESTION) {
          this.dialogRef.close('no')
          return;
        }
        if (!isNew) {
          this.dialogRef.close('no')
          this.route.navigate([`/modules/activity-type/${ACTIVITY_TYPE}/${SKILL}/${MODULE_KEY}/${activity.key}`])
          return;
        }
        this.form.reset();
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.isCreate = false;
        this.inputEl.nativeElement.focus();
        this.route.navigate([`/modules/activity-type/${ACTIVITY_TYPE}/${SKILL}/${MODULE_KEY}/${activity.key}`])
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}